export default __webpack_public_path__ + "static/media/appearance.e8a96d39.svg";